/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Tbc native api delegate.
 */
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldMobileNativeApi = exports.OldMobileNativeCore = exports.NativeType = void 0;
var events_1 = require("events");
var sdk_1 = require("@xbase/sdk");
var type_1 = require("@xunlei/xluser-base/dist/common/type");
var interface_1 = require("./interface");
var windowAny = window;
var NativeType;
(function (NativeType) {
    NativeType[NativeType["ios"] = 1] = "ios";
    NativeType[NativeType["android"] = 2] = "android";
    NativeType[NativeType["unknown"] = 3] = "unknown";
})(NativeType = exports.NativeType || (exports.NativeType = {}));
/**
 * Old mobile native core.
 */
var OldMobileNativeCore = /** @class */ (function () {
    /**
     * constructor
     *
     * @param {string} name
     */
    function OldMobileNativeCore(name) {
        this._name = name;
        this._native = null;
        this._nativeType = undefined;
        this._isSdkNative = false;
        this._lastCallbackFunctionNameId = 0;
        this._callbackFunctionEvent = new events_1.EventEmitter();
    }
    /**
     * Init.
     */
    OldMobileNativeCore.prototype.init = function () {
        this._initNative();
    };
    Object.defineProperty(OldMobileNativeCore.prototype, "name", {
        /**
         *
         */
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldMobileNativeCore.prototype, "native", {
        /**
         * Get native object.
         */
        get: function () {
            return this._native;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Is sdk native.
     * @return {boolean}
     */
    OldMobileNativeCore.prototype.isSdkNative = function () {
        return this._isSdkNative;
    };
    /**
     * On.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    OldMobileNativeCore.prototype.on = function (type, listener) {
        // eslint-disable-next-line new-cap
        this.native.AttachNativeEvent(type, function () {
            if (typeof listener === 'function') {
                listener();
            }
        });
        return this;
    };
    /**
     * Off.
     * @param {string | number} type
     * @param {NativeCoreListener} listener
     * @return {this}
     */
    OldMobileNativeCore.prototype.off = function (type, listener) {
        return this;
    };
    /**
     * Check if support CheckFunction.
     * @return {boolean}
     */
    OldMobileNativeCore.prototype.supportCheckFuncion = function () {
        return false;
    };
    /**
     * Check function.
     * @param {string} functionName
     * @return {Promise<NativeCoreCheckFunctionResponse>}
     */
    OldMobileNativeCore.prototype.checkFunction = function (functionName) {
        var naError = {
            error: sdk_1.ErrorType.NOT_FOUND,
        };
        return Promise.reject(naError);
    };
    /**
     * Call.
     * @param {any[]} args
     * @return {Promise<T>}
     */
    OldMobileNativeCore.prototype.call = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var functionName = args[0];
        var data = typeof args[1] !== 'undefined' ? args[1] : '';
        return this._callNativeFunction(functionName, data);
    };
    /**
     * Get new callback function name.
     * @return {string}
     */
    OldMobileNativeCore.prototype._getNewCallbackFunctionName = function () {
        var functionPreName = this._name + "_OldClientNativeCallbackFunction";
        var newFunctionName = '';
        do {
            var newId = this._lastCallbackFunctionNameId++;
            newFunctionName = functionPreName + newId;
        } while (windowAny[newFunctionName] !== undefined);
        return newFunctionName;
    };
    /**
     * Get new callback function promise.
     * @param {string} callbackFunctionName
     * @return {Promise<any>}
     */
    OldMobileNativeCore.prototype._getNewCallFunctionPromise = function (callbackFunctionName) {
        var _this = this;
        windowAny[callbackFunctionName] = function (result) {
            _this._callbackFunctionEvent.emit(callbackFunctionName, result);
            windowAny[callbackFunctionName] = undefined;
        };
        var promise = new Promise(function (resolve, reject) {
            _this._callbackFunctionEvent.once(callbackFunctionName, function (resultStr) {
                var result = type_1.parseJson(resultStr);
                var naError = _this._toNAError(result);
                if (naError) {
                    reject(naError);
                }
                else {
                    resolve(result);
                }
            });
        });
        return promise;
    };
    /**
     * Call native function.
     * @param {string} functionName
     * @param {any} data
     * @return {Promise<any>}
     */
    OldMobileNativeCore.prototype._callNativeFunction = function (functionName, data) {
        if (data === void 0) { data = ''; }
        var canCallNativeFunction = false;
        var promise = null;
        if (this._nativeType === NativeType.ios ||
            this._nativeType === NativeType.android) {
            canCallNativeFunction = true;
        }
        if (canCallNativeFunction) {
            var callbackFunctionName = this._getNewCallbackFunctionName();
            promise = this._getNewCallFunctionPromise(callbackFunctionName);
            switch (this._nativeType) {
                case NativeType.ios: {
                    data = !data ? {} : data;
                    data = JSON.stringify(Object.assign(data, {
                        actionName: functionName,
                        jsCallBack: callbackFunctionName,
                    }));
                    this._native.postMessage(data);
                    break;
                }
                case NativeType.android: {
                    data = !!data ? JSON.stringify(data) : data;
                    this._native.sendMessage(functionName, data, callbackFunctionName);
                    break;
                }
                default: {
                    break;
                }
            }
        }
        if (promise) {
            return promise;
        }
        else {
            var naError = {
                error: sdk_1.ErrorType.LOCAL,
                error_description: "wrong native type: " + this._nativeType,
            };
            return Promise.reject(naError);
        }
    };
    /**
     * To native error.
     * @param {any} data
     * @return {ResponseError | null}
     */
    OldMobileNativeCore.prototype._toNAError = function (data) {
        var naError = {
            error: sdk_1.ErrorType.UNKNOWN,
        };
        if (this._isSdkNative) {
            if (!data || (data && data.errcode)) {
                naError = {
                    error: sdk_1.ErrorType.UNKNOWN,
                    details: data.errcode,
                };
            }
            else {
                naError = null;
            }
        }
        else {
            if (!data || (data && data.internalError)) {
                naError = {
                    error: sdk_1.ErrorType.UNKNOWN,
                    details: data.internalError,
                };
            }
            else {
                naError = null;
            }
        }
        return naError;
    };
    /**
     * Init native.
     */
    OldMobileNativeCore.prototype._initNative = function () {
        if (typeof windowAny.webkit != 'undefined' &&
            typeof windowAny.webkit.messageHandlers &&
            typeof windowAny.webkit.messageHandlers.XLJSWebViewBridgeExport !=
                'undefined') {
            this._nativeType = NativeType.ios;
            this._isSdkNative = true;
            this._native =
                windowAny.webkit.messageHandlers['XLJSWebViewBridgeExport'];
        }
        else if (typeof windowAny.webkit != 'undefined' &&
            typeof windowAny.webkit.messageHandlers &&
            typeof windowAny.webkit.messageHandlers.XLJSWebViewBridge != 'undefined') {
            this._nativeType = NativeType.ios;
            this._isSdkNative = false;
            this._native = windowAny.webkit.messageHandlers['XLJSWebViewBridge'];
        }
        else if (typeof windowAny.XLJSWebViewBridgeExport != 'undefined') {
            this._nativeType = NativeType.android;
            this._isSdkNative = true;
            this._native = windowAny['XLJSWebViewBridgeExport'];
        }
        else if (typeof windowAny.XLJSWebViewBridge != 'undefined') {
            this._nativeType = NativeType.android;
            this._isSdkNative = false;
            this._native = windowAny['XLJSWebViewBridge'];
        }
        else {
            this._nativeType = NativeType.unknown;
            this._isSdkNative = false;
            this._native = null;
        }
    };
    return OldMobileNativeCore;
}());
exports.OldMobileNativeCore = OldMobileNativeCore;
/**
 * Old mobile native api.
 */
var OldMobileNativeApi = /** @class */ (function (_super) {
    __extends(OldMobileNativeApi, _super);
    /**
     * constructor
     *
     * @param {string} name
     */
    function OldMobileNativeApi(name) {
        var _this = _super.call(this) || this;
        _this._name = name;
        _this._nativeCore = new OldMobileNativeCore(name);
        return _this;
    }
    Object.defineProperty(OldMobileNativeApi.prototype, "name", {
        /** */
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OldMobileNativeApi.prototype, "nativeCore", {
        /**
         * Get native core.
         */
        get: function () {
            return this._nativeCore;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Init.
     */
    OldMobileNativeApi.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._nativeCore.init();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get app info.
     */
    OldMobileNativeApi.prototype.getAppInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appInfo, appInfoData, appInfoData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appInfo = {};
                        if (!this.nativeCore.isSdkNative()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nativeCore.call('nativeGetUserDeviceInfo', '')];
                    case 1:
                        appInfoData = _a.sent();
                        if (appInfoData) {
                            if (appInfoData.appid) {
                                appInfo.appId = appInfoData.appid;
                            }
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.nativeCore.call('xlGetAppMetaData', '')];
                    case 3:
                        appInfoData = _a.sent();
                        if (appInfoData) {
                            if (appInfoData.businessType) {
                                appInfo.appId = appInfoData.businessType;
                            }
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/, appInfo];
                }
            });
        });
    };
    /**
     * Get session user info.
     */
    OldMobileNativeApi.prototype.getSessionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, userInfoData, userInfoData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {};
                        if (!this.nativeCore.isSdkNative()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.nativeCore.call('nativeGetUserDeviceInfo', '')];
                    case 1:
                        userInfoData = _a.sent();
                        if (userInfoData) {
                            result.userId = userInfoData.userid.toString();
                            result.sessionId = userInfoData.session;
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.nativeCore.call('xlGetUserInfo', {
                            // 不强制用户登录
                            forceLogin: 0,
                            source: 'sdk',
                        })];
                    case 3:
                        userInfoData = _a.sent();
                        if (userInfoData && userInfoData.isLogin == 1 && userInfoData.userInfo) {
                            result.userId = userInfoData.userInfo.userID.toString();
                            result.sessionId = userInfoData.userInfo.sessionID;
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    return OldMobileNativeApi;
}(interface_1.NativeApi));
exports.OldMobileNativeApi = OldMobileNativeApi;
//# sourceMappingURL=old-mobile-native-api.js.map